'use client';
import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import { Search, MapPin } from 'lucide-react';

export default function HeroSearchBar() {
  const [query, setQuery] = useState('');
  const [location, setLocation] = useState('');
  const router = useRouter();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    router.push('/search-results-page');
  };

  return (
    <form onSubmit={handleSearch} className="flex flex-col sm:flex-row gap-2 max-w-2xl">
      <div className="relative flex-1">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Business name or type..."
          className="input-field pl-9 py-3 text-base"
          aria-label="Search businesses"
        />
      </div>
      <div className="relative sm:w-52">
        <MapPin size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          placeholder="Town or postcode..."
          className="input-field pl-9 py-3 text-base"
          aria-label="Location"
        />
      </div>
      <button type="submit" className="btn-primary py-3 px-6 text-base whitespace-nowrap">
        <Search size={16} />
        Search
      </button>
    </form>
  );
}